module.exports = {
  ROUTING_CHANGE: "ROUTING_CHANGE"
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/routing/EventTypes.js